import React from "react";
import { Routes, Route } from "react-router-dom";

import { ApiAuthProvider } from "./context/ApiContext";
import ProtectedRoute      from "./components/ProtectedRoute";

import Home from "./pages/Home/Home";

export default function App() {
    return (
        <ApiAuthProvider>
            {/* Le bouton de déconnexion est rendu par la barre de Home :
                le monter aussi ici l'affichait deux fois. */}
            <Routes>
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Home />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </ApiAuthProvider>
    );
}
